import { connect } from 'react-redux';
import App from '../App';
import { getEvents } from '../modules/geojson';
import { selectIsSearchActive } from '../modules/search';

export default connect(
  state => ({
    isSearchActive: selectIsSearchActive(state),
  }),
  { getEvents },
)(App);
